import type { AdminJsonComponentConfig } from '@apps/websiteCustomJsonComponents/types';
import { createLazyComponentFromNamedExport } from '@shared/utils/createLazyComponent';
import { VipGrabber } from './VipSidebar';
import { VIP_SCHEMA_URL, VIP_COMPONENT_TYPE } from './Vip.constants';

// Lazy load view components
const VipAdd = createLazyComponentFromNamedExport(() => import(/* webpackChunkName: "content/websiteEditorVipAdd" */ './VipSidebar'), 'VipAdd');

const VipEdit = createLazyComponentFromNamedExport(() => import(/* webpackChunkName: "content/websiteEditorVipEdit" */ './admin/VipEdit'), 'VipEdit');

// Add this object to CUSTOM_JSON_COMPONENT_TYPES in
// src/apps/websiteCustomJsonComponents/config.ts
export const VipConfig: AdminJsonComponentConfig = {
  schemaUrl: VIP_SCHEMA_URL,
  componentType: VIP_COMPONENT_TYPE,
  adminSidebarComponent: {
    addComponentView: VipAdd,
    dragComponentView: VipGrabber,
    editComponentView: VipEdit,
    createComponentView: VipEdit,
  },
};
